import {tns} from "tiny-slider";

export function homeIntroSlider() {

    let sliderElement   = document.querySelector('.js-home-intro-slider');


    if(sliderElement) {
        var slider = tns({
            container: '.js-home-intro-slider',
            controls: true,
            controlsContainer: '.js-home-intro-slider-controls',
            mouseDrag: true,
            nav: false,

        })
    }

    return 'homeIntroSlider';
}
